<template>
  <div class="footer-wrap" v-show="show">
    <div class="footer__shaodw"></div>
    <div class="container text-center">
      <h1 class="square">ABOUT COMPANY</h1>
      <div class="introduction">
        <p>北京伟嘉安捷投资担保有限公司成立于2006年3月15日。</p>
        <p>是一家为个人提供房产按揭引荐服务、房产权证服务的专业机构，注册资金为5000万元。</p>
        <p>专业性是伟嘉安捷最大的特点。</p>
        <p>公司拥有一支精通金融理财、政策法规及房地产专业知识的精英队伍，致力于为借款人提供全面的贷款经纪及按揭理财服务。</p>
        <p>伟嘉安捷依托深厚的房地产从业背景、坚实的银行合作基础、大量优质的客户，自成立之初至现在占据了较大的市场份额。</p>
      </div>
      <hr>
      <div class="copy">
        &copy; 2019 <span>北京伟嘉安捷投资担保有限公司</span> All rights reserved&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;京ICP备16040229号-2&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;<a class="credentials" href="//image.91weijia.com/91weijia/PublicLicense/credentials.html" target="_blank">证照公示</a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Footer',
    props: {
      show: {
        type: Boolean,
        default: true
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .footer-wrap
    position relative
    height 274px
    background-image url(/static/img/bg3.png)
    background-repeat no-repeat
    background-position center top
    background-size cover
    .footer__shaodw
      position absolute
      width 100%
      height 100%
      background-color rgba(0, 0, 0, 0.8)
    .container
      position relative
    h1.square
      margin 30px 0 14px
      font-size 44px
      color #fff
      font-weight normal
      letter-spacing 4px
    .introduction
      font-size 14px
      color #fff
      p
        margin 0
        line-height 24px
    hr
      margin-bottom 10px
      border-top 1px solid rgba(255, 255, 255, 0.3)
    .copy
      margin-bottom 10px
      font-size 12px
      color #fff
      span, .credentials
        color #2b9efc

</style>



// WEBPACK FOOTER //
// footer.vue?534d253d